export const en = {
    experimentsArchive: '{experimentsArchiveName} - archive'
};
